export const  headerData =  {
    "nombres": "afiliado",
    "fechaNacimiento": "",
    "sexo": "",
    "modalidadPension": "RP",
    "monedaPension": "SA",
    "saldoNoAfecto": 0,
    "saldoAfecto": 0,
    "esquemaComision": "F",
    "promedioRemuneraciones": 0,
    "remuneracionActual": 0,
    "nroRemuneraciones": "12",
    "nroMensualidades": "12",
    "pctContribucionObl": 10,
    "regularidadAportes": 60,
    "saldoVoluntario": 0,
    "fondoObligatorio": {
        "tipo": "2",
        "rentabilidad": 5
    },
    "fondoVoluntario": {
        "tipo": "2",
        "rentabilidad": 5
    },
    "tasasInteres": [
        {
            "tipo": "AFP",
            "moneda": "S",
            "valor": 3.19
        }
    ],
    "beneficiarios": []
};
